/**
 * GAM targeting value normalization and the publisher-provided id. Kept free
 * of page-state imports (experiment and study buckets) so the lazy Stories
 * bundle can use it alone; lib/gamTargeting.js re-exports it.
 * @module lib/gamTargetingValue
 */

const GAM_MAX_TARGETING_VALUE_LENGTH = 40;

function normalizeTargetingValue(value) {
  if (value === undefined || value === null) {
    return '';
  }

  const normalized = String(value).trim();
  if (!normalized) {
    return '';
  }

  const lowered = normalized.toLowerCase();
  if (lowered === 'undefined' || lowered === 'null') {
    return '';
  }

  return normalized.slice(0, GAM_MAX_TARGETING_VALUE_LENGTH);
}

// The GAM publisher-provided id is the derived, consent-gated ads id the
// identity module placed on `window.ppid` (plans/ads-identity-unification.md,
// 2026-09-09). The former fallback to the Prebid sharedId is gone: no ads id
// means no PPID.
function resolvePublisherProvidedId({ runtimeWindow } = {}) {
  const resolvedWindow = runtimeWindow || (typeof window !== 'undefined' ? window : null);
  return normalizeTargetingValue(resolvedWindow?.ppid) || '';
}

module.exports = {
  GAM_MAX_TARGETING_VALUE_LENGTH,
  normalizeTargetingValue,
  resolvePublisherProvidedId
};
